import './style.scss';
import { gsap } from "gsap";

export function text_image_hero_block() {
  const block = document.querySelector('.text_image_hero_block');
  if (!block) return;
  
  
  const notFoundBlock = document.querySelector('.not-found-page');
  
  if (notFoundBlock) {
    const ball = block.querySelector(".ball")
    const stones = block.querySelector(".stones")

    gsap.to(ball, {
      rotate: 0,
      duration:2.5,
      ease: "back.out(1.1)"
    })

    gsap.to(stones, {
      opacity:1,
      scale:1,
      delay:1.1,
      duration:.3,
      ease:"power2"
    })
  }
  
}
